/**
 * ユーザーズガイド特別リンク処理のプリセット設定
 *
 * 一部のカードはCMSの既定リンク先をそのまま使わず、
 * モーダルダイアログで複数のリンク先を選択させる必要がある。
 * 将来的に別のカードにも特別処理を追加する場合は、ここにプリセットを追加する。
 *
 * matchId: microCMSのユーザーズガイドデータのid（一意キー）
 */
const presets = [
  {
    // マッチ条件: microCMSのユーザーズガイドid
    matchId: '034',
    // モーダルのタイトル
    title: '対象カードをご選択ください',
    // モーダル内のリンク一覧
    links: [
      {
        label: 'セゾンゴールド・アメリカン・エキスプレス\u00AE・カード',
        url: '/csmembers/gold/',
      },
      {
        label: 'セゾンゴールド・アメリカン・エキスプレス・カード（年会費優遇型）',
        url: '/csmembers/gold-next0/',
      },
      {
        label: 'セゾンゴールド・アメリカン・エキスプレス・カード（旧ウォルマートカードセゾン）',
        url: '/static2/lp/14xu202201/',
      },
    ],
  },
]

export default presets
